/** @format */

import React, { useRef, useEffect } from "react";
import Hero from "./Hero";
import Services from "./Services";
import LongevityPillars from "./LongevityPillars";
import ContactForm from "./ContactForm";

const Home: React.FC = () => {
  const contactFormRef = useRef<HTMLDivElement>(null);

  // Custom scroll function with adjustable duration
  const scrollToElement = (element: HTMLElement, duration: number = 1500) => {
    if (!element) return;

    const startPosition = window.pageYOffset;
    const targetPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime: number | null = null;

    function animation(currentTime: number) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      // Easing function for smoother animation
      const ease = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      window.scrollTo(0, startPosition + distance * ease(progress));

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  };

  useEffect(() => {
    // Check if the URL has a hash that matches the contact form
    if (
      window.location.hash === "#subscribe" ||
      window.location.hash === "#contact"
    ) {
      // Use our custom scroll function with longer duration (slower scroll)
      if (contactFormRef.current) {
        // Small timeout to ensure DOM is fully loaded
        setTimeout(() => {
          scrollToElement(contactFormRef.current!);
        }, 100);
      }
    }
  }, []);

  return (
    <>
      <Hero />
      <Services />
      <LongevityPillars />
      <div id="contact" ref={contactFormRef}>
        <ContactForm />
      </div>
    </>
  );
};

export default Home;
